/*
 *  Product Thumbnail Add To Cart
 *
 *
 *  Version:
 *    1.0.0 - 2020/02/14
 */
import {
  handlize, generateIcon, escapeString, getCountOfVariantInCart, pictureGenerate,
  printMoney, addToCart, ON_CART_FINISHED
} from '@process-creative/slate-theme-tools';
import { generateLoader } from './../../objects/loader/Loader';
import { DiscountMessaging } from './../discount-messaging/DiscountMessaging';

const CONTAINER_SELECTOR = '[data-product-thumbnail]';
const SELECTOR_ADD_BUTTON = '[data-product-thumbnail-add-to-cart-button]';
const SWATCH_BUTTON_SELECTOR = '[data-product-thumbnail-swatch-button]';
const SWATCH_SELECT_SELECTOR = '[data-product-thumbnail-swatch-select]'
const SELECTOR_PRODUCT_DATA = '[data-product-json]';
const IMAGE_SELECTOR = '[data-product-thumbnail-image]';
const SELECTOR_MONEY = '[data-product-thumbnail-price]';
const SELECTOR_DISCOUNT = '[data-product-thumbnail-discount]';
const SWATCH_SHOWMORE_BUTTON = '[data-swatches-showmore-btn]';

const VARIANT_ID_ATTR = 'data-variant-id';

const WAITLIST_PRODUCT_THUMBNAIL_BUTTON = '[data-product-thumbnail-add-to-waitlist-button]';

const WISH_LIST_COLLECTION_BUTTON = '[data-product-thumbnail-button]';

const getVariantStatus = variant => {
  if(variant.inventory_management == 'shopify' &&
    variant.inventory_policy == 'continue' &&
    variant.inventory_quantity <= 0
  ) return 'PREORDER';
  if(!variant.available && !variant.waitlist_eta) return 'SOLDOUT';
  if(!variant.available && variant.waitlist_eta) return 'WAITLIST';
  if(variant.inventory_management == 'shopify' &&
    variant.inventory_policy == 'deny' &&
    getCountOfVariantInCart(variant.id) >= variant.inventory_quantity
  ) return 'ALL';
  return 'AVAILABLE';
}

const getActiveVariant = container => container.attr(VARIANT_ID_ATTR);

const getActiveVariantData = container => {
  const data = container.find(SELECTOR_PRODUCT_DATA);
  if(!data || !data.length) return '';
  let json = JSON.parse(data.html());

  let activeVariantId = getActiveVariant(container);
  let activeVariant = json.variants.find(v => v.id == activeVariantId);
  activeVariant.product = json;
  return activeVariant;
}

const getSwatchHTMLFromContainer = (container) => {
  try {
    let active = getActiveVariantData(container);
    return getSwatchHTML(active.product, active);
  } catch(e) {
    console.error(e);
    return '';
  }
}
const getVariantBasedOnIndex = (index, variants) => {
  let v = variants.find((v,i) => (i == index));
  return v?v:null;
}

export const getSwatchHTML = (product,variant) => {
  if(!product || !variant) return '';
  let [ disabled, text, condition ] = getButtonStatus(variant);

  let swatches = '';

  //hide swatches when variant is on waitlist
  if(product.variants.length >= 2 && condition != 'WAITLIST') {
    swatches = Object.entries(product.options_with_values).reduce((x,y,i) => {
      const [ optionName, option ] = y;
      const optionHandle = handlize(option.name);

      //Don't print dimensions
      if(option.values.length < 2) return x;
      if(optionHandle == 'dimensions') return x;

      let showMore = '';
      if (option.values.length > 5) {
        showMore = `
          <button class="o-swatches__more o-btn o-btn--underline"
            data-swatches-showmore-btn
          >
            + ${option.values.length - 5} more
          </button>
        `;
      }

      let isSelected = val => variant.options[i] === val;

      //Color specific swatches
      if(['color','colour'].some(o => optionHandle == o)) {
        return `${x}<div class="o-swatches__swatch has-js is-color">
          <div class="o-swatches__swatch-options">
            ${printMoney(variant.price)}
          </div>
        </div>`;
      }

      return `${x}<div class="o-swatches__swatch is-default has-js">
        <select class="o-swatches__swatch-select"
          data-product-thumbnail-swatch-select
          data-swatch-position="${option.position}"
        >
        ${option.values.reduce((p,value,index) => {
          let selected = isSelected(value);
          return `${p}
            <option value="${value}" ${selected?'selected':''}>
              ${value} - ${printMoney(getVariantBasedOnIndex(index,product.variants).price)}
              ${getVariantBasedOnIndex(index,product.variants).available? ``:
              escapeString(Language.strings['products.product.sold_out'])}
            </option>
          `;
        } ,'')}
        </select>
      </div>`;

    }, '');
  }

  //if it's on the waitlist/soldout
  // if (condition=='WAITLIST' || condition=='SOLDOUT' ) {
  //   let url = `${product.url.split('?')[0]}?variant=${variant.id}`;
  //   return `

  //   <div class="o-product-thumbnail__add-container is-mobile">
  //     <div class="o-product-thumbnail__add">
  //       ${swatches && swatches != '' ? `<div class="o-product-thumbnail__swatch"> ${swatches} </div>` : '' }
  //       <a href="${url}" data-product-thumbnail-add-to-waitlist-button
  //         class="o-btn o-product-thumbnail__add-button  c-collection-template__product-notify-link"
  //       >
  //         ${variant.waitlist_eta?
  //           escapeString(Language.strings['products.product.join_waitlist']):
  //           escapeString(Language.strings['products.product.sold_out'])}
  //       </a>
  //     </div>
  //   </div>`;
  // }
  //if it can be added to cart
  return `${swatches && swatches != '' ? `${swatches}` : '' }`;

}

const setThumbnailSwatch = (thumbnail, swatch, value) => {
  let position = parseInt(swatch.attr('data-swatch-position'));
  let swatchesForPosition = thumbnail.find(`[data-swatch-position="${position}"]`);
  swatchesForPosition.removeClass('is-selected');
  swatchesForPosition.filter(`[data-value="${value}"]`).addClass('is-selected');

  //Find variant that matches
  const product = JSON.parse(thumbnail.find(SELECTOR_PRODUCT_DATA).html());
  const selectedOptions = [];
  Object.entries(product.options_with_values).forEach(([optionName,option]) => {
    let pos = option.position;
    //Is this the position that was updated?
    if(pos == position) {
      selectedOptions.push(value);
      return;
    }

    //Get current position value
    let selectedValue = thumbnail.find(`[data-swatch-position="${pos}"]`);
    if(!selectedValue || !selectedValue.length) {
      selectedOptions.push(option.selected);
      return;
    }
    let val = selectedValue.val() || selectedValue.attr('data-value');
    selectedOptions.push(val);
  });

  let selectedVariant = product.variants.find(v => {
    return v.options.every((o,i) => {
      if (i > 1) return true;
      return selectedOptions[i] == o;
    });
  });

  //Update variant id for add button
  thumbnail.attr(VARIANT_ID_ATTR, selectedVariant.id);

  //Update price
  const money = thumbnail.find(SELECTOR_MONEY);
  let isDiscounted = selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price;
  let saving = Math.round(
    ((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100
  );

  //if it's on waitlist
  if (selectedVariant.waitlist_eta && !selectedVariant.available) {
    money.html(`
    <p class="o-product-thumbnail__waitlist-message">
    ${Language.strings['products.product.waitlist_message']} ${escapeString(selectedVariant.waitlist_eta)}
    </p>`);
  } else {
    money.html(`
    ${isDiscounted ? `
      <span class="o-product-thumbnail__price-compare-original"
        data-currency
        data-money="${selectedVariant.compare_at_price}"
        data-product-compare-money
      >
        ${printMoney(selectedVariant.compare_at_price)}
      </span>`
    : '' }
    <span class="o-product-thumbnail__price" data-currency data-product-money data-money="${selectedVariant.price}">
      ${printMoney(selectedVariant.price)}
    </span>
  `);
  //update wishlist

    // let wishlistButton  = thumbnail.find(`[data-product-thumbnail-button]`);
    // window._swat.fetch( function(wishlistProducts) {
    //   let isInWishlist = wishlistProducts.find(function(p){
    //     return p.empi == product.id && p.epi == selectedVariant.id;
    //   });
    //   if(isInWishlist){
    //     wishlistButton.addClass('is-saved');
    //     wishlistButton.attr('disabled', 'disabled');
    //   } else {
    //     wishlistButton.removeClass('is-saved');
    //     wishlistButton.removeAttr('disabled', 'disabled');
    //   }
    // })
  }

  let image = selectedVariant.featured_image &&
    selectedVariant.featured_image.src ?
    selectedVariant.featured_image.src : product.image;

  thumbnail.find(IMAGE_SELECTOR).html(
    pictureGenerate({ src: image,
      srcSize: 480,
      sizes: [
        { size: 165, screen: 375 },
        { size: 230, screen: 500 },
        { size: 240, screen: 750 },
        { size: 315, screen: 1000 },
        { size: 350, screen: 1350 },
        { size: 424, screen: 1650 },
        { size: 480, screen: 2000 }
      ],
      lazy: {dataSrc: true, class: true},
      class:'o-product-thumbnail__image',
      attributes:'itemprop="image"'
    })
  );

  //Update add button
  let button = thumbnail.find(SELECTOR_ADD_BUTTON);
  if (!button.length) {
    button = thumbnail.find(WAITLIST_PRODUCT_THUMBNAIL_BUTTON);
  }

  updateButton(button, selectedVariant, product);
}

const updateButton = (button, variant) => {
  let [ disabled, text, condition ] = getButtonStatus(variant);

  if (condition == 'SOLDOUT' || condition == 'WAITLIST') {
    let url = button.closest(CONTAINER_SELECTOR).find(IMAGE_SELECTOR).attr('href');
    //if it's on the recently viewed / you may also like
    if (!url) url = button.closest(CONTAINER_SELECTOR).find('.o-product-thumbnail__image-container a').attr('href');
    if (url.toString().indexOf('?') !== -1) url = url.split('?')[0]+ '?variant=' + variant.id;

    button.after(`
      <a href="${url}"
        class="o-btn o-product-thumbnail__add-button
          c-collection-template__product-notify-link"
        data-product-thumbnail-add-to-waitlist-button
      >
      ${variant.waitlist_eta?
        escapeString(Language.strings['products.product.join_waitlist']):
        escapeString(Language.strings['products.product.sold_out_notify_me'])}
      </a>`);
    button.remove();
    return;
  } else if (condition == 'ALL') {

    button.text(text);
    button.addClass('is-disabled');
    button.attr('is-disabled','');
    button.closest('.o-product-thumbnail__add-container').find('.o-product-thumbnail__swatch-price-container').hide();

    setTimeout(() => {
      button.closest('.o-product-thumbnail__add-container').find('.o-product-thumbnail__swatch-price-container').show();
      button.after(`
        <button
          type="submit"
          class="o-btn o-product-thumbnail__add-button"
          data-product-thumbnail-add-to-cart-button
        >
          <span>Quick Add</span>
        </button>`);
      button.remove();
    }, 2000);

  } else {
    button.after(`
    <button data-product-thumbnail-add-to-cart-button type="button"
      ${disabled?'disabled="true"':''}
      class="o-btn o-product-thumbnail__add-button ${disabled?'is-disabled':''} "
    >
      <span>Quick Add</span>
    </button>`);
    button.remove();
  }

  if(disabled) {
    button.addClass('is-disabled').attr('disabled', 'disabled');
  } else {
    button.removeClass('is-disabled').removeAttr('disabled');
  }
  button.removeAttr('was-added');

}

export const getButtonStatus = variant => {
  let disabled,text,condition;
  let status = getVariantStatus(variant);
  switch(status) {
    case 'PREORDER':
      disabled = false;
      condition = 'PREORDER';
      text = Language.strings['products.product.preorder_button'];
      break;

    case 'SOLDOUT':
      disabled = false;
      condition = 'SOLDOUT';
      text = Language.strings['products.product.sold_out'];
      break;

    case 'WAITLIST':
      disabled = false;
      condition = 'WAITLIST';
      text = Language.strings['products.product.join_waitlist'];
      break;

    case 'ALL':
      disabled = true;
      condition = 'ALL';
      text = Language.strings['products.product.all_in_cart'];
      break;

    default:
      disabled = false
      condition = 'ADD';
      text = `${generateIcon('plus', 'o-product-thumbnail__add-button__plus')}
      ${generateIcon('plus-white', 'o-product-thumbnail__add-button__plus-white')}`;
      break;
  }
  return [ disabled, text, condition];
}


$(document).ready(() => {
  $(CONTAINER_SELECTOR).each((i,e) => {
    const container = $(e);
    let htmlData = getSwatchHTMLFromContainer(container);

    const child = container.find('[data-product-swatch-selector]');
    if(!child || !child.length) return;

    [...child].forEach(c => {
      if (!htmlData) return;
      if( typeof( $(c).attr('data-product-swatch-thumbnail') ) != 'undefined' && $(c).find('.o-swatches__swatch.has-js').length == 0) {
        return;
      } else {
        $(c).html(htmlData);
      }
    })


    //Discount message display logic
    let collections = JSON.parse(container.find(SELECTOR_PRODUCT_DATA).html()).collections;
    let discountContainer = container.find(SELECTOR_DISCOUNT);
    DiscountMessaging(collections, discountContainer);

    //Colour swatches
    const colourSwatches = container.find('[data-product-thumbnail-swatch-button]');
    const swatchShowmoreBtn = container.find(SWATCH_SHOWMORE_BUTTON);
    if (colourSwatches.length > 5) swatchShowmoreBtn.text(`+ ${colourSwatches.length - 5} more`);
  })
});

$(document).on('click', SELECTOR_ADD_BUTTON, async e => {
  ['preventDefault','stopPropagation'].map(x => e[x]());
  const button = $(e.currentTarget);
  const thumbnail = button.closest(CONTAINER_SELECTOR);
  if(button.attr('disabled')) return;

  //Pending
  button.addClass('is-disabled');
  button.attr('disabled', 'disabled');
  button.html(generateLoader(null, null, null, 16));

  try {
    await addToCart(getActiveVariant(thumbnail), 1);
    button.attr('was-added', 'true');
    $('[data-cart-drawer-toggle]')[0].click();
  } catch(e) {
    //Handle errors
    console.error(e);
    alert(e && e.message ? e.description : e);
    updateButton(button, getActiveVariantData(thumbnail));
  }
});

$(document).on('click touchend', SWATCH_BUTTON_SELECTOR, e => {
  const button = $(e.currentTarget);
  const thumbnail = button.closest(CONTAINER_SELECTOR);
  setThumbnailSwatch(thumbnail, button, button.attr('data-value'));
});

$(document).on('change', SWATCH_SELECT_SELECTOR, e => {
  const select = $(e.currentTarget);
  const thumbnail = select.closest(CONTAINER_SELECTOR);
  setThumbnailSwatch(thumbnail, select, select.val());
});


$(document).on(ON_CART_FINISHED, e => {
  $(SELECTOR_ADD_BUTTON).each((i,e) => {
    let btn = $(e);
    let container = btn.closest(CONTAINER_SELECTOR);

    if(btn.attr('was-added')) {
      // btn.text(Language.strings['products.product.added_to_cart']);
      btn.html(`${generateIcon('tick', 'o-product-thumbnail__add-button__tick')}`)
      setTimeout(() => {
        updateButton(btn, getActiveVariantData(container));
      }, 2000);
    } else {
      updateButton(btn, getActiveVariantData(container));
    }
  })
});

$(document).on('click touchend', SWATCH_SHOWMORE_BUTTON, e => {
  e.preventDefault(), e.stopPropagation();
  let self = $(e.currentTarget);
  self.css('display', 'none');
  let timeout = 0;
  const productThumbnail = self.closest('[data-product-thumbnail]');
  const colourSwatches = productThumbnail.find('[data-product-thumbnail-swatch-button]');
  colourSwatches.each((i, el) => {
    setTimeout(() => $(el).addClass('is-show-more'), timeout);
    timeout += 50;
  });
});
/*
$(document).on('click', WISH_LIST_COLLECTION_BUTTON, async e => {
  ['preventDefault','stopPropagation'].map(x => e[x]());
  const button = $(e.currentTarget);
  const thumbnail = button.closest(CONTAINER_SELECTOR);
  if(button.attr('disabled')) return;

  let variantData = getActiveVariantData(thumbnail);
  let productData =  JSON.parse(thumbnail.find(SELECTOR_PRODUCT_DATA).html());

  let countEl = $('[data-wishlist-count]');
  let countElMobile = $('[data-wishlist-count-mobile]');
  window._swat.fetch( function(wishlistProducts) {
    window._swat.addToWishList(
      {
       "epi":  variantData.id,
       "empi": productData.id,
       "iu" :  variantData.featured_image.src,
       "pr":   variantData.price,
      },
      function(r) {
        //console.log("variant added ", variantData.id)
     }
    );
     button.addClass('is-saved');
     button.attr('disabled', 'disabled');
      //Manually increment counter
     countEl.html(wishlistProducts.length + 1)
     countElMobile.html(` &nbsp;(${wishlistProducts.length + 1})`)
  })
}); */

//update wishlist buttons status
/*  $(document).ready(() => {
  $(WISH_LIST_COLLECTION_BUTTON).each((i,e) => {
    const button = $(e);
    const thumbnail = button.closest(CONTAINER_SELECTOR);
    let variantData = getActiveVariantData(thumbnail);
    let productData =  JSON.parse(thumbnail.find(SELECTOR_PRODUCT_DATA).html());
    window._swat.fetch( function(wishlistProducts) {
      let isInWishlist = wishlistProducts.find(function(p){
        return p.empi == productData.id && p.epi == variantData.id;
      });
      if(isInWishlist){
        button.addClass('is-saved');
        button.attr('disabled', 'disabled');
      }
      })
    })
});
 */


